import axios from 'axios';
import { useCallback, useMemo } from 'react';
import { colors } from '../../../../../../../colors';
import AssetIcon from '../../../../../../../components/AssetIcon';
import { BotState } from '../../../../../types';
import './index.css';

import ServicePaths from '../../../../../../../bridge/utils/ServicePaths';

interface Props {
  state: BotState;
  handleMove: (state: BotState) => void;
}

const StateListItem = (props: Props) => {
  const { state, handleMove } = props;
  const { baseAsset, quoteAsset, isActive, botId, isDisabled } = state;

  const buttonColor = useMemo(
    () => (isActive ? colors.red : colors.green),
    [isActive],
  );

  const buttonText = useMemo(() => (isActive ? 'Stop' : 'Start'), [isActive]);

  const handleClick = useCallback(async () => {
    if (isDisabled) {
      return;
    }

    const { data } = await axios({
      method: 'POST',
      url: isActive
        ? ServicePaths.CONTROL.StopBot
        : ServicePaths.CONTROL.StartBot,
      params: {
        botId,
      },
    });

    if (!data?.success) {
      return;
    }

    handleMove(state);
  }, [botId, handleMove, isActive, isDisabled, state]);

  return (
    <div className="states-item-root">
      <div className="states-item-asset-icon">
        <AssetIcon baseAsset={state.baseAsset} width={40} height={40} />
      </div>
      <span className="bi-asset-container states-item-margin-fix">
        <h4 className="bi-asset-text-label">BaseAsset:</h4>
        <h4 className="bi-asset-text">{baseAsset}</h4>
      </span>
      <span className="bi-asset-container states-item-margin-fix">
        <h4 className="bi-asset-text-label">QuoteAsset:</h4>
        <h4 className="bi-asset-text">{quoteAsset}</h4>
      </span>

      <div
        className="states-item-button"
        style={{
          backgroundColor: isDisabled ? '#808080' : buttonColor,
          cursor: isDisabled ? 'default' : 'pointer',
        }}
        onClick={handleClick}
      >
        <p
          className="states-item-button-text"
          style={{
            color: isDisabled ? '#242424' : colors.white,
          }}
        >
          {buttonText}
        </p>
      </div>
    </div>
  );
};

export default StateListItem;
